import React from 'react';
import styled from 'styled-components';

interface IProps {
  children: React.ReactNode;
}

const OverlayBlurLayout = ({ children }: IProps) => {
  return <StyledWrapper>{children}</StyledWrapper>;
};

const StyledWrapper = styled.div`
  z-index: 9999;

  position: fixed;
  top: 0px;
  left: 0px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 100px;

  width: 100%;
  height: 100%;

  backdrop-filter: blur(2px);
`;

export default OverlayBlurLayout;
